// Kept as narrow as the control allows so the gap before the next column stays small. The widest
// state is Working's pill (spinner + text) plus its separate stop button, and the cell adds 8px of
// left padding and clips anything past its width - narrow this further and the stop button is the
// first thing cut off. Every locale currently ships the English labels; if a translation runs
// longer than "Working…", revisit this. Shared so the row cell and its header cell (and, on
// task-table-v3, the table's own width budget) can't drift out of sync with each other.
export const NOVA_INVOCATION_COLUMN_WIDTH = 130;
